import request from '@/utils/request';

// 列表
export function moduleList(options) {
  return request({
    url: `/op/module/pageList`,
    method: 'get',
    params: options
  });
}
// 修改模块
export function moduleEdit(options, id) {
  return request({
    url: `/op/module/update/${id}`,
    method: 'post',
    data: options
  });
}
// 修改模块
export function moduleAdd(options) {
  return request({
    url: `/op/module/`,
    method: 'post',
    data: options
  });
}
// 添加模块
export function moduleDel(id) {
  return request({
    url: `/op/module/${id}`,
    method: 'DELETE'
  });
}
